import { createClient } from '@supabase/supabase-js';

// ── RLS (Row Level Security) — Supabase SQL Editor'de çalıştırılacak ──
// ALTER TABLE kullanicilar ENABLE ROW LEVEL SECURITY;
// ALTER TABLE depo ENABLE ROW LEVEL SECURITY;
// ALTER TABLE seferler ENABLE ROW LEVEL SECURITY;
// ALTER TABLE musteriler ENABLE ROW LEVEL SECURITY;
// ALTER TABLE odemeler ENABLE ROW LEVEL SECURITY;
// ALTER TABLE sefer_musteriler ENABLE ROW LEVEL SECURITY;
// ALTER TABLE gumruk_adimlar ENABLE ROW LEVEL SECURITY;
//
// CREATE POLICY "anon_all" ON kullanicilar FOR ALL TO anon USING (true) WITH CHECK (true);
// CREATE POLICY "anon_all" ON depo FOR ALL TO anon USING (true) WITH CHECK (true);
// CREATE POLICY "anon_all" ON seferler FOR ALL TO anon USING (true) WITH CHECK (true);
// CREATE POLICY "anon_all" ON musteriler FOR ALL TO anon USING (true) WITH CHECK (true);
// CREATE POLICY "anon_all" ON odemeler FOR ALL TO anon USING (true) WITH CHECK (true);
// CREATE POLICY "anon_all" ON sefer_musteriler FOR ALL TO anon USING (true) WITH CHECK (true);
// CREATE POLICY "anon_all" ON gumruk_adimlar FOR ALL TO anon USING (true) WITH CHECK (true);

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);
